var postal = require("common/PubSub");
var Utils = require("common/Utils");

/**
 * @constructor
 */
function TOTPMenuView() {
    var $listview = $("<ul data-role='listview'>");
    var $content = $("<div>", {id : "totpMenu"}).append($listview);

    function addEntry(title, eventName) {
        var $li = $("<li>").append($("<a>", {text : title}));
        $li.on("click", function() {
            postal.channel("TOTPSettingsDelegate").publish(eventName);
        });
        $listview.append($li);
        return $li;
    }

    const enrollmentEntry = addEntry($.t("common::totp.reEnrollment.title"), "show-enrollment-view");
    const backupCodesEntry = addEntry($.t("common::totp.backupCodes.title"), "show-backup-codes-view");

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "TOTPMenu";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::totp.title"),
            i18n : "common::totp.title"
        };
    };

    this.setEnrollmentState = function(isTOTPEnabled, isSelfEnrolledEnabled, isEnrolled) {
        if (isTOTPEnabled) {
            if (isEnrolled) {
                enrollmentEntry.find("a").text($.t("common::totp.reEnrollment.title"));
            } else {
                enrollmentEntry.find("a").text($.t("common::totp.enrollment.title"));
            }
        }
        Utils.setElementEnabled(enrollmentEntry, isTOTPEnabled && isSelfEnrolledEnabled);
        Utils.setElementEnabled(backupCodesEntry, isTOTPEnabled && isEnrolled);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return false;
    };
}

TOTPMenuView.prototype = require("common/AbstractView");

module.exports = TOTPMenuView;


//////////////////
// WEBPACK FOOTER
// ./settings/totp/TOTPMenuView.js
// module id = 96
// module chunks = 0 3